import React from 'react';

// Global skeleton neutralizer applied via className to ensure no inherited glows
const skeletonBaseClass = "skeleton-neutralizer";

export function SkeletonCard({ children, className = "" }) {
  return (
    <div 
      className={`p-6 rounded-2xl bg-white dark:bg-[#141414] border border-gray-200 dark:border-[rgba(255,255,255,0.05)] shadow-none ${skeletonBaseClass} ${className}`} 
      style={{ boxShadow: 'none', filter: 'none', outline: 'none' }}
    >
      {children}
    </div>
  );
}

export function SkeletonText({ width = "w-full", height = "h-4", className = "" }) {
  return (
    <div 
      className={`rounded bg-gray-200 dark:bg-[#1f1f1f] animate-pulse ${width} ${height} ${skeletonBaseClass} ${className}`} 
      style={{ boxShadow: 'none', filter: 'none', outline: 'none' }} 
    />
  );
}

export function SkeletonChart({ height = "h-[300px]", type = "bar", className = "" }) {
  return (
    <div 
      className={`w-full rounded-lg bg-gray-100 dark:bg-[#141414] border border-gray-200 dark:border-[rgba(255,255,255,0.05)] flex flex-col justify-end p-4 gap-2 animate-pulse ${height} ${skeletonBaseClass} ${className}`} 
      style={{ boxShadow: 'none', filter: 'none', outline: 'none' }}
    >
      {type === "bar" && (
        <div className="flex items-end justify-between w-full h-full gap-2 pt-8">
          <div className="w-full bg-gray-200 dark:bg-[#1f1f1f] rounded-t-sm h-[30%]" style={{ boxShadow: 'none' }} />
          <div className="w-full bg-gray-200 dark:bg-[#1f1f1f] rounded-t-sm h-[60%]" style={{ boxShadow: 'none' }} />
          <div className="w-full bg-gray-200 dark:bg-[#1f1f1f] rounded-t-sm h-[45%]" style={{ boxShadow: 'none' }} />
          <div className="w-full bg-gray-200 dark:bg-[#1f1f1f] rounded-t-sm h-[80%]" style={{ boxShadow: 'none' }} />
          <div className="w-full bg-gray-200 dark:bg-[#1f1f1f] rounded-t-sm h-[25%]" style={{ boxShadow: 'none' }} />
          <div className="w-full bg-gray-200 dark:bg-[#1f1f1f] rounded-t-sm h-[50%]" style={{ boxShadow: 'none' }} />
          <div className="w-full bg-gray-200 dark:bg-[#1f1f1f] rounded-t-sm h-[90%]" style={{ boxShadow: 'none' }} />
        </div>
      )}
      {type === "circle" && (
        <div className="flex items-center justify-center w-full h-full">
          <div className="w-48 h-48 rounded-full border-8 border-gray-200 dark:border-[#202020]" style={{ boxShadow: 'none', filter: 'none' }} />
        </div>
      )}
      {type === "table" && (
        <div className="flex flex-col gap-4 w-full h-full mt-4">
          <div className="h-8 w-full rounded bg-gray-200 dark:bg-[#1f1f1f]" style={{ boxShadow: 'none' }} />
          <div className="h-8 w-full rounded bg-gray-200 dark:bg-[#1f1f1f]" style={{ boxShadow: 'none' }} />
          <div className="h-8 w-full rounded bg-gray-200 dark:bg-[#1f1f1f]" style={{ boxShadow: 'none' }} />
          <div className="h-8 w-full rounded bg-gray-200 dark:bg-[#1f1f1f]" style={{ boxShadow: 'none' }} />
          <div className="h-8 w-full rounded bg-gray-200 dark:bg-[#1f1f1f]" style={{ boxShadow: 'none' }} />
        </div>
      )}
    </div>
  );
}

export function SkeletonMetric() {
  return (
    <SkeletonCard>
      <SkeletonText width="w-[40%]" height="h-4" className="mb-5" />
      <SkeletonText width="w-[60%]" height="h-8" className="mb-3" />
      <SkeletonText width="w-[75%]" height="h-3" />
    </SkeletonCard>
  );
}
